import React, {Component, Fragment} from 'react';
import {BreadcrumbsItem} from "react-breadcrumbs-dynamic";
import {withTranslation} from "react-i18next";
import {GelContentContainer, Content, Link, FormBack, Image, Utility, Sanitize} from 'cw-styleguide-react';
import SecondaryAutocompleteSearch from "../../../components/SecondaryAutocompleteSearch";
import {route} from "../../../routes";
import Helmet from 'react-helmet';

class JobRoleView extends Component {
  render() {
    return (
      <Fragment>
        <Helmet>
          <title>{this.props.data.name} - {this.props.t('route_role_title')} | {this.props.t('route_app_title')}</title>
        </Helmet>

        <BreadcrumbsItem to={route('job', {job: this.props.data.slug}) + '/' + route('jobRole')}>
          {this.props.t('route_role_title')}
        </BreadcrumbsItem>
        <GelContentContainer>
          <h1>{this.props.t('route_role_title')}</h1>

          {/* Introduction */}
          {!!this.props.data.image &&
          <Image hero={true} source={this.props.data.image.src} alternative={this.props.data.image.alt}/>
          }

            <Sanitize html={this.props.data.role} tag={"div"} classes={['style--list-circle','style--list-no-bg']}/>

          <hr/>
          <h3 id={Utility.slug(this.props.t('more_information_title'))}>{this.props.t('more_information_title')}</h3>
          <ul className="style style--list-large">
            <li>
              <Link to={route('job', {job: this.props.data.slug}) + '/' + route('jobPay')}>
                {this.props.t('route_pay_title')}
              </Link>
            </li>
            <li>
              <Link to={route('job', {job: this.props.data.slug}) + '/' + route('jobBecome')}>
                {this.props.t('route_become_title')}
              </Link>
            </li>
            <li>
              <Link to={route('job', {job: this.props.data.slug}) + '/' + route('jobSkills')}>
                {this.props.t('route_skills_title')}
              </Link>
            </li>
          </ul>
          <FormBack url={route('job', {job: this.props.data.slug})} title={this.props.data.name}/>
          <hr className="thick"/>
          <SecondaryAutocompleteSearch  jobs={this.props.jobs}/>
        </GelContentContainer>
      </Fragment>
    )
  }
}

export default withTranslation('local')(JobRoleView);
